import { createContext } from "react";

export const DeletePackageContext = createContext({});
